import React, { useState ,useEffect,useRef} from 'react';
import { Button} from '@mui/material';
import { styled } from '@mui/material/styles';
import '../Customize_Css/AddDeliveryVendor.css';
import location from '../Icons/location.svg';
import uploadicon from '../Icons/upload white.svg';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { prepareUploadFile, getUploadErrorMessage } from '../utils/prepareUploadFile';
import 'react-toastify/dist/ReactToastify.css';
import removeIcon from '../Icons/Close-white.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";

// Fix Leaflet default icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
});

const UpdateDeliveryVendor = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [validFields, setValidFields] = useState({});
  const { id: DeliveryVendorId } = useParams(); 
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const AuthorizationToken = localStorage.getItem('token');
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  console.log("epicxTenantId", epicxTenantId);
  const [timeAvailabilitySlot, setTimeAvailabilitySlot] = useState([]);
  const [daySlot, setDaySlot] = useState([]);
  //map picker state
  const [isMapOpen, setIsMapOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null); // { lat, lng }
  const [searchQuery, setSearchQuery] = useState("");
  const [manualLat, setManualLat] = useState("");
  const [manualLng, setManualLng] = useState("");
  const [mapMarker, setMapMarker] = useState(null);
  const mapRef = useRef(null);

  const mapCenter = [11.0168, 76.9558]; // Default center
  const mapZoom = 13;
  const Input = styled('input')({
    display: 'none',
  });
  
  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    setFiles((prev) => ({
      ...prev,
      [name]: file ? { name: file.name, file } : null, 
    }));
  };


  const handleButtonClick = (time) => {
    setTimeAvailabilitySlot([time]); 
  };
  
  const handleDaySelection = (day) => {
    setDaySlot((prev) => {
      if (prev.includes(day)) {
        return prev.filter((slot) => slot !== day);
      } else {
        return [...prev, day];
      }
    });
  };
  const handleDaysButtonClick = (day) => {
    setDaySlot(prevDays =>
      prevDays.includes(day)
        ? prevDays.filter(d => d !== day)
        : [...prevDays, day]
    );
  };
  
const handleAccountTypeChange = (accountType) => {
  setFormData((prevFormData) => ({
    ...prevFormData,
    typeOfAccount: accountType, 
  }));
};
const handleLocationClick = () => {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      const location = `Latitude: ${position.coords.latitude}, Longitude: ${position.coords.longitude}`;
      setFormData((prev) => ({ ...prev, useMyLocation: location }));
    },
    (error) => {
      console.error("Error getting location:", error);
    }
  );
};

const [formData, setFormData] = useState({
  deliveryVendorShopName: '',
  fullName: '',
  emailAddress: '',
  degree: '',
  primaryMobileNumber: '',
  whatsappNumber: '',
  country: '',
  state: '',
  city: '',
  dateOfBirth: '',
  gstNumber: '',
  panNumber: '',
  address: '',
  useMyLocation: '',
  currentLocation: '',
  nameOfEmergency: '',
  relationshipToAccountHolder: '',
  emergencyPhoneNumber: '',
  emergencyEmailAddress: '',
  emergencyAddress: '',
  alternateContactPersonName: '',
  relationshipToAlternateContactPerson: '',
  alternateContactPersonNumber: '',
  alternateContactPersonAddress: '',
  toPickupLocationTime: '',
  toDeliveryLocationTime: '',
  maximumDeliveryCapacity: '',
  accountHoldersName: '',
  typeOfAccount: '',
  accountNumber: '',
  ifscCode: '',
  branchName: '',
  gpayNumber: '',
  bankAddress: ''
});
const [files, setFiles] = useState({
  gstFile: null,
  panFile: null,
  profilePictureFile: null
});
const handleFileRemove = (name) => {
  setFiles((prev) => ({ ...prev, [name]: null }));
};
const toDateInputValue = (value) => {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
};
useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/deliveryVendor/api/deliveryVendor/${epicxTenantId}/${DeliveryVendorId}`,
        {
          headers: {
              Authorization: `Bearer ${AuthorizationToken}`,
            },
          }
      );
      const data = response.data;

      console.log(data, "Fetched Vendor Data");
      setFormData((prevState) => ({
        ...prevState,
        deliveryVendorShopName: data.deliveryVendorShopName || '',
        fullName: data.fullName || '',
        emailAddress: data.emailAddress || '',
        degree: data.degree || '',
        primaryMobileNumber: data.primaryMobileNumber || '',
        whatsappNumber: data.whatsappNumber || '',
        country: data.country || '',
        state: data.state || '',
        city: data.city || '',
        dateOfBirth: toDateInputValue(data.dateOfBirth),
        gstNumber: data.gstNumber || '',
        panNumber: data.panNumber || '',
        address: data.address || '',
        useMyLocation: data.useMyLocation || '',
        currentLocation: data.currentLocation || '',
        nameOfEmergency: data.nameOfEmergency || '',
        relationshipToAccountHolder: data.relationshipToAccountHolder || '',
        emergencyPhoneNumber: data.emergencyPhoneNumber || '',
        emergencyEmailAddress: data.emergencyEmailAddress || '',
        emergencyAddress: data.emergencyAddress || '',
        alternateContactPersonName: data.alternateContactPersonName || '',
        relationshipToAlternateContactPerson: data.relationshipToAlternateContactPerson || '',
        alternateContactPersonNumber: data.alternateContactPersonNumber || '',
        alternateContactPersonAddress: data.alternateContactPersonAddress || '',
        toPickupLocationTime: data.toPickupLocationTime || '',
        toDeliveryLocationTime: data.toDeliveryLocationTime || '',
        maximumDeliveryCapacity: data.maximumDeliveryCapacity || '',
        accountHoldersName: data.accountHoldersName || '',
        typeOfAccount: data.typeOfAccount || '',
        accountNumber: data.accountNumber || '',
        ifscCode: data.ifscCode || '',
        branchName: data.branchName || '',
        gpayNumber: data.gpayNumber || '',
        bankAddress: data.bankAddress || '',
      }));
      setTimeAvailabilitySlot(data.timeAvailabilitySlot || []);
      setDaySlot(data.daySlot || []);
      setFiles((prev) => ({
        gstFile: data.gstFile
          ? { name: 'Current GST File', url: data.gstFile }
          : null,
        panFile: data.panFile
          ? { name: 'Current PAN File', url: data.panFile }
          : null,
        profilePictureFile: data.profilePictureFile
          ? { name: 'Current Profile Picture', url: data.profilePictureFile }
          : null,
      }));
    } catch (error) {
      console.error('Error fetching vendor data:', error);
    }
  };

  fetchData();
}, [epicxTenantId, DeliveryVendorId]);

const validateFormDeliveryVendor = () => {
  let errors = {};
  let isValid = true;
  const isValidIFSC = (ifsc) => /^[A-Za-z]{4}\d{7}$/.test(ifsc);

  // Helper function for checking empty fields
  const isEmpty = (value) => !value || value.trim() === "";

  // Helper function to check a valid email
  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // Helper function to check a valid mobile number (10-digit numeric)
  const isValidMobileNumber = (number) =>
    /^[0-9]{10}$/.test(number);

  // Helper function to check GST format (15 characters alphanumeric)
  const isValidGST = (gst) =>
    /^[0-9A-Z]{15}$/.test(gst);

  // Helper function to check PAN format (5 letters, 4 digits, 1 letter)
  const isValidPAN = (pan) =>
    /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan);

  // **Checking required fields**
  if (isEmpty(formData.deliveryVendorShopName)) {
    errors.deliveryVendorShopName = "Delivery Vendor Shop Name is required";
    isValid = false;
  }
  if (isEmpty(formData.fullName)) {
    errors.fullName = "Full Name is required";
    isValid = false;
  }
  if (isEmpty(formData.emailAddress) || !isValidEmail(formData.emailAddress)) {
    errors.emailAddress = "Valid Email Address is required";
    isValid = false;
  }
  if (isEmpty(formData.degree)) {
    errors.degree = "Degree is required";
    isValid = false;
  }
  if (isEmpty(formData.primaryMobileNumber) || !isValidMobileNumber(formData.primaryMobileNumber)) {
    errors.primaryMobileNumber = "Valid 10-digit Primary Mobile Number is required";
    isValid = false;
  }
  if (isEmpty(formData.whatsappNumber) || !isValidMobileNumber(formData.whatsappNumber)) {
    errors.whatsappNumber = "Valid 10-digit WhatsApp Number is required";
    isValid = false;
  }
  if (isEmpty(formData.country)) {
    errors.country = "Country selection is required";
    isValid = false;
  }
  if (isEmpty(formData.state)) {
    errors.state = "State selection is required";
    isValid = false;
  }
  if (isEmpty(formData.city)) {
    errors.city = "City selection is required";
    isValid = false;
  }
  if (isEmpty(formData.dateOfBirth)) {
    errors.dateOfBirth = "Date of Birth is required";
    isValid = false;
  }
  if (isEmpty(formData.gstNumber) || !isValidGST(formData.gstNumber)) {
    errors.gstNumber = "Valid 15-character GST Number is required";
    isValid = false;
  }
  if (!files.gstFile) {
    errors.gstFile = "GST File is required";
    isValid = false;
  }
  if (isEmpty(formData.panNumber) || !isValidPAN(formData.panNumber)) {
    errors.panNumber = "Valid PAN Number is required";
    isValid = false;
  }
  if (!files.panFile) {
    errors.panFile = "PAN File is required";
    isValid = false;
  }
  if (isEmpty(formData.address)) {
    errors.address = "Address is required";
    isValid = false;
  }
  if (isEmpty(formData.currentLocation)) {
    errors.currentLocation = "Current Location is required";
    isValid = false;
  }
  if (timeAvailabilitySlot.length === 0) {
    errors.timeAvailabilitySlot = "Select at least one Time Slot";
    isValid = false;
  }
  if (daySlot.length === 0) {
    errors.daySlot = "Select at least one Day Slot";
    isValid = false;
  }
  if (!files.profilePictureFile) {
    errors.profilePictureFile = "Profile Picture is required";
    isValid = false;
  }
   // Required field validations
   if (isEmpty(formData.nameOfEmergency)) {
    errors.nameOfEmergency = "Name of Emergency is required";
    isValid = false;
  }
  if (isEmpty(formData.relationshipToAccountHolder)) {
    errors.relationshipToAccountHolder = "Relationship to Account Holder is required";
    isValid = false;
  }
  if (isEmpty(formData.emergencyPhoneNumber) || !isValidMobileNumber(formData.emergencyPhoneNumber)) {
    errors.emergencyPhoneNumber = "Valid 10-digit Emergency Phone Number is required";
    isValid = false;
  }
  if (isEmpty(formData.emergencyEmailAddress) || !isValidEmail(formData.emergencyEmailAddress)) {
    errors.emergencyEmailAddress = "Valid Email Address is required";
    isValid = false;
  }
  if (isEmpty(formData.emergencyAddress)) {
    errors.emergencyAddress = "Emergency Contact Person Address is required";
    isValid = false;
  }
  if (isEmpty(formData.toPickupLocationTime)) {
    errors.toPickupLocationTime = "To Pickup Location Time is required";
    isValid = false;
  }
  if (isEmpty(formData.toDeliveryLocationTime)) {
    errors.toDeliveryLocationTime = "To Delivery Location Time is required";
    isValid = false;
  }
  if (isEmpty(formData.maximumDeliveryCapacity)) {
    errors.maximumDeliveryCapacity = "Maximum Delivery Capacity is required";
    isValid = false;
  }
  if (isEmpty(formData.accountHoldersName)) {
    errors.accountHoldersName = "Account Holder's Name is required";
    isValid = false;
  }
  if (isEmpty(formData.typeOfAccount)) {
    errors.typeOfAccount = "Type of Account selection is required";
    isValid = false;
  }
  if (isEmpty(formData.accountNumber)) {
    errors.accountNumber = "Account Number is required";
    isValid = false;
  }
  if (isEmpty(formData.ifscCode) || !isValidIFSC(formData.ifscCode)) {
    errors.ifscCode = "Valid IFSC Code is required";
    isValid = false;
  }
  if (isEmpty(formData.branchName)) {
    errors.branchName = "Branch Name is required";
    isValid = false;
  }
  if (isEmpty(formData.gpayNumber) || !isValidMobileNumber(formData.gpayNumber)) {
    errors.gpayNumber = "Valid 10-digit Gpay Number is required";
    isValid = false;
  }
  if (isEmpty(formData.bankAddress)) {
    errors.bankAddress = "Bank Address is required";
    isValid = false;
  }

  // **Set the errors state**
  setErrors(errors);

  return isValid;
};

const handleUpdate = async () => {
  const isValid = validateFormDeliveryVendor();
  if (!isValid) {
    toast.error('Please correct the errors in the form before submitting.');
    return;
  }

  try {
    const formDataToSend = new FormData();

    if (formData.useMyLocation?.latitude && formData.useMyLocation?.longitude) {
      formDataToSend.append('useMyLocation', JSON.stringify(formData.useMyLocation));
    } else {
      formDataToSend.append('useMyLocation', ''); 
    }

    Object.keys(formData).forEach((key) => {
      if (key !== 'useMyLocation') { 
        formDataToSend.append(key, formData[key] || '');
      }
    });

    if (files.gstFile?.file) {
      formDataToSend.append('gstFile', await prepareUploadFile(files.gstFile.file));
    } else if (files.gstFile?.url) {
      formDataToSend.append('gstFileUrl', files.gstFile.url);
    }

    if (files.panFile?.file) {
      formDataToSend.append('panFile', await prepareUploadFile(files.panFile.file));
    } else if (files.panFile?.url) {
      formDataToSend.append('panFileUrl', files.panFile.url);
    }

    if (files.profilePictureFile?.file) {
      formDataToSend.append('profilePictureFile', await prepareUploadFile(files.profilePictureFile.file));
    } else if (files.profilePictureFile?.url) {
      formDataToSend.append('profilePictureFileUrl', files.profilePictureFile.url);
    }

    formDataToSend.append('timeAvailabilitySlot', JSON.stringify(timeAvailabilitySlot));
    formDataToSend.append('daySlot', JSON.stringify(daySlot));

    // Now send
    const response = await axios.put(
      `${BASE_URL}/deliveryVendor/api/deliveryVendor/${DeliveryVendorId}`,
      formDataToSend,
      {
        headers: {
          Authorization: `Bearer ${AuthorizationToken}`,
        },
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
      }
    );

    toast.success('Delivery Vendor updated successfully!');
    console.log(response.data);
    setTimeout(() => navigate('/view-delivery-vendor'), 700);
  } catch (error) {
    console.error('Error updating delivery vendor:', error.response?.data || error.message);
    toast.error(getUploadErrorMessage(error, 'Update failed'));
  }
};
function MapClickHandler({ onSelect }) {
  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      onSelect({ lat, lng });
    },
  });
  return null;
}
const updateLocation = (loc) => {
  setSelectedLocation(loc);
  setMapMarker(loc);
  setManualLat(loc.lat.toFixed(6));
  setManualLng(loc.lng.toFixed(6));

  setFormData(prev => ({
    ...prev,
    useMyLocation: { latitude: loc.lat.toString(), longitude: loc.lng.toString() }
  }));
};

const handleGeocode = async () => {
  if (!searchQuery.trim()) return;

  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}`
    );
    const data = await res.json(); 
    if (!data || data.length === 0) {
      toast.error("Location not found");
      return;
    }

    const { lat, lon } = data[0];
    const newLoc = { lat: parseFloat(lat), lng: parseFloat(lon) };
    updateLocation(newLoc);
    mapRef.current?.setView(newLoc, 16);
  } catch (err) {
    console.error(err);
    toast.error("Search failed");
  }
};

useEffect(() => {
  if (formData.useMyLocation?.latitude && formData.useMyLocation?.longitude) {
    const lat = parseFloat(formData.useMyLocation.latitude);
    const lng = parseFloat(formData.useMyLocation.longitude);
    if (!isNaN(lat) && !isNaN(lng)) {
      const loc = { lat, lng };
      setSelectedLocation(loc);
      setMapMarker(loc);
      setManualLat(lat.toFixed(6));
      setManualLng(lng.toFixed(6));
    }
  }
}, [formData.useMyLocation]);

useEffect(() => {
  if (isMapOpen && mapRef.current) {
    setTimeout(() => mapRef.current?.invalidateSize(), 100);
  }
}, [isMapOpen]);


  return (
    <>
      <Sidebar/>
  <div className="delivery-form-page">
    <div className='container'>
        <header className="delivery-form-hero">
          <div>
            <p className="delivery-form-kicker">Vendors</p>
            <h1>Update Delivery Vendor</h1>
            <p>Review and update shop, contact, documents, availability, and bank details.</p>
          </div>
          <button type="button" className="delivery-form-back" onClick={() => navigate('/view-delivery-vendor')}>
            Back to Vendors
          </button>
        </header>
        <div style={{display:'flex',flexDirection:'column',gap:'20px'}}>
        <div className="card">
          <div className="card-header bg-light d-flex justify-content-between align-items-center">
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12h8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <h5>Delivery Vendor Information</h5>
                        <div style={{display:'flex',justifyContent:'flex-end',width:'100%'}}>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2" fill="red" />
                        <path d="M8 8l8 8M16 8l-8 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        </div>
                    </div>
          <div className="card-body" style={{display:'flex',flexDirection:'column',gap:'10px'}}>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="deliveryVendorShopName">Delivery Vendor Shop Name</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input
                    type="text"
                    // className="form-control bg-light"
                    className={`form-control bg-light ${errors.deliveryVendorShopName ? 'is-invalid' : validFields.deliveryVendorShopName ? 'is-valid' : ''}`}
                    id="deliveryVendorShopName"
                    name="deliveryVendorShopName"
                    onChange={handleInputChange}
                    value={formData.deliveryVendorShopName}
                  />
                  {errors.deliveryVendorShopName && <small className="text-danger">{errors.deliveryVendorShopName}</small>}

                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="fullName">Full Name</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input
                    type="text"
                    // className="form-control bg-light"
                    className={`form-control bg-light ${errors.fullName ? 'is-invalid' : validFields.fullName ? 'is-valid' : ''}`}
                    id="fullName"
                    name="fullName"
                    onChange={handleInputChange}
                    value={formData.fullName}
                 
                  />
                  {errors.fullName && <small className="text-danger">{errors.fullName}</small>}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="emailAddress">Email Address</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input
                    type="email"
                    // className="form-control bg-light"
                    className={`form-control bg-light ${errors.emailAddress ? 'is-invalid' : validFields.emailAddress ? 'is-valid' : ''}`}
                    id="emailAddress"
                    name="emailAddress" 
                    onChange={handleInputChange}
                    value={formData.emailAddress}   
                    readOnly  
                  />
                  {errors.emailAddress && <small className="text-danger">{errors.emailAddress}</small>}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="degree">Degree</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input type="text" 
                  // className="form-control bg-light" 
                  className={`form-control bg-light ${errors.degree ? 'is-invalid' : validFields.degree ? 'is-valid' : ''}`}
                  id="degree"
                   name="degree"
                   onChange={handleInputChange}
                   value={formData.degree}  
                  />
                  {errors.degree && <small className="text-danger">{errors.degree}</small>}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="primaryMobileNumber">Primary Mobile Number</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input type="text" 
                  // className="form-control bg-light" 
                  className={`form-control bg-light ${errors.primaryMobileNumber ? 'is-invalid' : validFields.primaryMobileNumber ? 'is-valid' : ''}`}
                  id="primaryMobileNumber"
                    name="primaryMobileNumber"
                    onChange={handleInputChange}
                   value={formData.primaryMobileNumber}
                   maxLength="10"
                   pattern="\d*"
                   inputMode="numeric"  
                   />
                  {errors.primaryMobileNumber && <small className="text-danger">{errors.primaryMobileNumber}</small>}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="whatsappNumber">Whatsapp Number</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input type="text" 
                  // className="form-control bg-light" 
                  className={`form-control bg-light ${errors.whatsappNumber ? 'is-invalid' : validFields.whatsappNumber ? 'is-valid' : ''}`}
                  id="whatsappNumber"
                   name="whatsappNumber"
                   onChange={handleInputChange}
                   value={formData.whatsappNumber} 
                   maxLength="10"
                   pattern="\d*"
                   inputMode="numeric" 
                  />
                  {errors.whatsappNumber && <small className="text-danger">{errors.whatsappNumber}</small>}
                </div>
              </div>
            </div>
            <div className='row'>
            <div className='col-md-4'>
              <label htmlFor='country'>Country</label>
              <span style={{ color: 'red' }}>*</span>
              <select id='country'
              //  className='form-select bg-light' 
              className={`form-control bg-light ${errors.country ? 'is-invalid' : validFields.country ? 'is-valid' : ''}`}
               style={{color:'gray'}}
              name="country"
              onChange={handleInputChange}
              value={formData.country} 
             >
                <option value=''>Select Country</option>
                <option value='India'>India</option>
              </select>
              {errors.country && <small className="text-danger">{errors.country}</small>}

            </div>
            <div className='col-md-4'>
              <label htmlFor='state'>State</label>
              <span style={{ color: 'red' }}>*</span>
              <select id='state' 
              // className='form-select bg-light'
              className={`form-control bg-light ${errors.state ? 'is-invalid' : validFields.state ? 'is-valid' : ''}`}

               style={{color:'gray'}}  name="state"
               onChange={handleInputChange}
               value={formData.state} 
             
             >
                <option value=''>Select State</option>
                <option value='Tamil Nadu'>Tamil Nadu</option>
              </select>
              {errors.state && <small className="text-danger">{errors.state}</small>}

            </div>
            <div className='col-md-4'>
              <label htmlFor='city'>City</label>
              <span style={{ color: 'red' }}>*</span>
              <select id='city' 
              // className='form-select bg-light' 
              className={`form-control bg-light ${errors.city ? 'is-invalid' : validFields.city ? 'is-valid' : ''}`}
              style={{color:'gray'}}
              name="city"
              onChange={handleInputChange}
              value={formData.city} 
             >
                <option value=''>Select City</option>
                <option value='Rajapalayam'>Rajapalayam</option>
                <option value='Sankarankovil'>Sankarankovil</option>
              </select>
              {errors.city && <small className="text-danger">{errors.city}</small>}

            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="dateOfBirth">Date of Birth</label>
                <span style={{ color: 'red' }}>*</span>
                <input type="date" 
                // className="form-control bg-light" 
              className={`form-control bg-light ${errors.dateOfBirth ? 'is-invalid' : validFields.dateOfBirth ? 'is-valid' : ''}`}
                id="dateOfBirth" name="dateOfBirth" 
                 onChange={handleInputChange}
                 value={formData.dateOfBirth} 
                />
              {errors.dateOfBirth && <small className="text-danger">{errors.dateOfBirth}</small>}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="gstNumber">GST Number</label>
                <span style={{ color: 'red' }}>*</span>
                <input type="text" 
                // className="form-control bg-light"
              className={`form-control bg-light ${errors.gstNumber ? 'is-invalid' : validFields.gstNumber ? 'is-valid' : ''}`}
                 id="gstNumber" 
                name="gstNumber"
                onChange={handleInputChange}
                value={formData.gstNumber}
                maxLength="15"
               />
              {errors.gstNumber && <small className="text-danger">{errors.gstNumber}</small>}
              </div>
            </div>
            <div className="col-md-4">
        <label>GST File</label>
        <span style={{ color: 'red' }}>*</span>
        <label className="vendor-upload-label" htmlFor="file-upload-button">
          <Input
            accept="/*" 
            id="file-upload-button"
            type="file"
            name="gstFile"
            onChange={handleFileChange}
            style={{ display: 'none' }} 
          />
          <Button
            variant="contained"
            component="span"
            endIcon={
              files.gstFile ? (
                <>
                  <span style={{ fontSize: '15px' }}>{files.gstFile.name}</span>
                  <img 
                    src={removeIcon} 
                    alt="Remove File Icon"
                    style={{ width: '20px', height: '20px', cursor: 'pointer' }} 
                    onClick={() => handleFileRemove('gstFile')}
                  />
                </>
              ) : (
                <img src={uploadicon} alt="Upload Icon" style={{ width: '20px', height: '20px' }} />
              )
            }
            className="vendor-field-action"
          >
            {files.gstFile ? '' : 'Upload'} 
          </Button>
        </label>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="panNumber">PAN Number</label>
                <span style={{ color: 'red' }}>*</span>
                <input type="text" 
                // className="form-control bg-light" 
              className={`form-control bg-light ${errors.panNumber ? 'is-invalid' : validFields.panNumber ? 'is-valid' : ''}`}
                id="panNumber" name="panNumber"
                onChange={handleInputChange}
                value={formData.panNumber}
               />
              {errors.panNumber && <small className="text-danger">{errors.panNumber}</small>}
              </div>
            </div>
            <div className="col-md-4">
        <label>PAN File Upload</label>
        <span style={{ color: 'red' }}>*</span>
        <label className="vendor-upload-label" htmlFor="pan-file-upload-button">
          <Input
            accept="/*" 
            id="pan-file-upload-button"
            type="file"
            name="panFile"
            onChange={handleFileChange}
            style={{ display: 'none' }} 
          />
          <Button
            variant="contained"
            component="span"
            endIcon={
              files.panFile ? (
                <>
                  <span style={{ fontSize: '15px' }}>{files.panFile.name}</span>
                  <img 
                    src={removeIcon} 
                    alt="Remove File Icon"
                    style={{ width: '20px', height: '20px', cursor: 'pointer' }} 
                    onClick={() => handleFileRemove('panFile')}
                  />
                </>
              ) : (
                <img src={uploadicon} alt="Upload Icon" style={{ width: '20px', height: '20px' }} />
              )
            }
            className="vendor-field-action"
          >
            {files.panFile ? '' : 'Upload'} 
          </Button>
        </label>
      </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="address">Address</label>
                <span style={{ color: 'red' }}>*</span>
                <textarea 
                // className="form-control bg-light" 
              className={`form-control bg-light ${errors.address ? 'is-invalid' : validFields.address ? 'is-valid' : ''}`}
                id="address" name="address" rows="2" 
                onChange={handleInputChange}
                value={formData.address}
               ></textarea>
              {errors.address && <small className="text-danger">{errors.address}</small>}
              </div>
            </div>
          </div>
          <div className='row'>
          {/* <div className='col-md-4'>
            <label htmlFor='currentLocationButton'>Use My Location</label>
            <span style={{ color: 'red' }}>*</span>
            <button
                type='button'
                id='currentLocationButton'
                className='btn d-flex justify-content-between align-items-center'
                style={{ backgroundColor: '#00B982', color: 'white', width: '100%' }}
                onClick={handleLocationClick} 
                name="useMyLocation"
                value={formData.useMyLocation}
            >
                <span>Current Location</span>
                <img src={location} alt="location" style={{ width: '20px', height: '20px' }} />
            </button>
      {errors.useMyLocation && <small className="text-danger">{errors.useMyLocation}</small>}
        </div> */}
        <div className='col-md-4'>
          <label>Use My Location <span style={{ color: 'red' }}>*</span></label>
          <button
            type="button"
            className={`btn d-flex justify-content-between align-items-center w-100 ${
              errors.useMyLocation ? 'border border-danger' : ''
            }`}
            style={{ backgroundColor: '#00B982', color: 'white' }}
            onClick={() => setIsMapOpen(true)}
          >
            <span>
              {selectedLocation
                ? `Picked: ${selectedLocation.lat.toFixed(4)}, ${selectedLocation.lng.toFixed(4)}`
                : 'Select Location on Map'}
            </span>
            <img src={location} alt="location" style={{ width: '20px', height: '20px' }} />
          </button>

          {selectedLocation && (
            <button
              type="button"
              className="btn btn-sm btn-link text-danger mt-1 p-0"
              onClick={() => {
                setSelectedLocation(null);
                setMapMarker(null);
                setManualLat("");
                setManualLng("");
                setFormData(prev => ({
                  ...prev,
                  useMyLocation: { latitude: '', longitude: '' }
                }));
              }}
            >
              Clear Location
            </button>
          )}

          {errors.useMyLocation && <small className="text-danger">{errors.useMyLocation}</small>}
        </div>
            <div className='col-md-8'>
              <label htmlFor='currentLocation'>Current Location</label>
              <span style={{ color: 'red' }}>*</span>
              <input 
                type='text' 
                id='currentLocation' 
                // className='form-control bg-light' 
              className={`form-control bg-light ${errors.currentLocation ? 'is-invalid' : validFields.currentLocation ? 'is-valid' : ''}`}
                name='currentLocation'
                onChange={handleInputChange}
                value={formData.currentLocation}
              />
      {errors.currentLocation && <small className="text-danger">{errors.currentLocation}</small>}
            </div>
          </div>
          <div className="row">
          <div className="col-md-12 buttonsgap">
        <label>Time Availability Slot</label>
        <span style={{ color: 'red' }}>*</span>
        <div className="btn-group" role="group" aria-label="Time Availability Slot">
          {['6:00 AM - 10:00 PM', '11:00 AM - 8:00 PM', '9:00 AM - 9:00 PM', '9:30 AM - 10:00 PM', '10:00 AM - 10:00 PM', '5:00 AM - 9:00 PM'].map(time => (
            <button
              key={time}
              type="button"
              className={`bg-light btn btn-outline-secondary slot-btn ${timeAvailabilitySlot.includes(time) ? 'active' : ''}`}
              onClick={() => handleButtonClick(time)}
              style={{ borderRadius: '4px' }}
            >
              {time}
            </button>
          ))}
        </div>
        </div>
        {errors.timeAvailabilitySlot && <small className="text-danger">{errors.timeAvailabilitySlot}</small>}

            </div>
          <div className="row">
                <div className="col-md-8 buttonsgap">
                <label>Day Slot</label>
        <span style={{ color: 'red' }}>*</span>
        <div className="btn-group" role="group" aria-label="Day Slot">
          {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(day => (
            <button
              key={day}
              type="button"
              className={`bg-light btn btn-outline-secondary day-btn ${daySlot.includes(day) ? 'active' : ''}`}
              onClick={() => handleDaySelection(day)}
              style={{ borderRadius: '4px' }}
            >
              {day}
            </button>
          ))}
        </div>
        {errors.daySlot && <small className="text-danger">{errors.daySlot}</small>}

                </div>
                <div className="col-md-4">
        <label>Your Profile Picture</label>
        <span style={{ color: 'red' }}>*</span>
        <label className="vendor-upload-label" htmlFor="profile-picture-upload-button">
          <Input
            accept="/*" 
            id="profile-picture-upload-button"
            type="file"
            name="profilePictureFile"
            onChange={handleFileChange}
            style={{ display: 'none' }} 
          />
          <Button
            variant="contained"
            component="span"
            endIcon={
              files.profilePictureFile ? (
                <>
                  <span style={{ fontSize: '15px' }}>{files.profilePictureFile.name}</span>
                  <img 
                    src={removeIcon}
                    alt="Remove File Icon"
                    style={{ width: '20px', height: '20px', cursor: 'pointer' }} 
                    onClick={() => handleFileRemove('profilePictureFile')}
                  />
                </>
              ) : (
                <img src={uploadicon} alt="Upload Icon" style={{ width: '20px', height: '20px' }} />
              )
            }
            className="vendor-field-action"
          >
            {files.profilePictureFile ? '' : 'Upload'} 
          </Button>
        </label>
                </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header bg-light d-flex justify-content-between align-items-center">
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12h8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <h5>Emergency Details</h5>
                        <div style={{display:'flex',justifyContent:'flex-end',width:'100%'}}>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2" fill="red" />
                        <path d="M8 8l8 8M16 8l-8 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        </div>
                    </div>
        <div className="card-body" style={{display:'flex',flexDirection:'column',gap:'10px'}}>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label htmlFor="nameOfEmergency">Name of Emergency</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text" id="nameOfEmergency" 
              // className="form-control bg-light"
              className={`form-control bg-light ${errors.nameOfEmergency ? 'is-invalid' : validFields.nameOfEmergency ? 'is-valid' : ''}`}
               name='nameOfEmergency'
               onChange={handleInputChange}
               value={formData.nameOfEmergency}
              
              />
      {errors.nameOfEmergency && <small className="text-danger">{errors.nameOfEmergency}</small>}

            </div>
            <div className="col-md-4 mb-3">
              <label htmlFor="relationshipToAccountHolder">Relationship to Account Holder</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text" id="relationshipToAccountHolder" 
              className={`form-control bg-light ${errors.relationshipToAccountHolder ? 'is-invalid' : validFields.relationshipToAccountHolder ? 'is-valid' : ''}`}
              // className="form-control bg-light"
               name='relationshipToAccountHolder'
               onChange={handleInputChange}
               value={formData.relationshipToAccountHolder}
             
              />
      {errors.relationshipToAccountHolder && <small className="text-danger">{errors.relationshipToAccountHolder}</small>}
            </div>
            <div className="col-md-4 mb-3">
              <label htmlFor="emergencyPhoneNumber">Emergency Phone Number</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text" id="emergencyPhoneNumber" 
              className={`form-control bg-light ${errors.emergencyPhoneNumber ? 'is-invalid' : validFields.emergencyPhoneNumber ? 'is-valid' : ''}`}
              // className="form-control bg-light"
               name='emergencyPhoneNumber'
               onChange={handleInputChange}
               value={formData.emergencyPhoneNumber}
               maxLength="10"
               pattern="\d*"
               inputMode="numeric"
             
              />
      {errors.emergencyPhoneNumber && <small className="text-danger">{errors.emergencyPhoneNumber}</small>}
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="emergencyEmailAddress">Emergency Email Address</label>
                <span style={{ color: 'red' }}>*</span>
                <input
                  type="email"
                  // className="form-control bg-light"
              className={`form-control bg-light ${errors.emergencyEmailAddress ? 'is-invalid' : validFields.emergencyEmailAddress ? 'is-valid' : ''}`}
                  id="emergencyEmailAddress"
                  name='emergencyEmailAddress'
                  onChange={handleInputChange}
                  value={formData.emergencyEmailAddress}
                 
                />
      {errors.emergencyEmailAddress && <small className="text-danger">{errors.emergencyEmailAddress}</small>}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="alternateContactPersonName">Alternate Contact Person Name</label>
                <input
                  type="text"
                  className="form-control bg-light"
                  id="alternateContactPersonName"
                  name='alternateContactPersonName'
                  onChange={handleInputChange}
                  value={formData.alternateContactPersonName}
                 
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="relationshipToAlternateContactPerson">Relationship to Alternate Contact Person</label>
                <input
                  type="text"
                  className="form-control bg-light"
                  id="relationshipToAlternateContactPerson"
                  name='relationshipToAlternateContactPerson'
                  onChange={handleInputChange}
                  value={formData.relationshipToAlternateContactPerson}
                 
                />
              </div>
            </div>
          </div>
          <div className="row">
          <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="alternateContactPersonNumber">Alternate Contact Person Number</label>
                <input type="text" id="alternateContactPersonNumber" className="form-control bg-light" 
                 name='alternateContactPersonNumber'
                 onChange={handleInputChange}
                 value={formData.alternateContactPersonNumber}
                 maxLength="10"
                 pattern="\d*"
                 inputMode="numeric"
               
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="emergencyAddress">Emergency Contact Person Address</label>
                <span style={{ color: 'red' }}>*</span>
                <textarea id="emergencyAddress" 
                // className="form-control bg-light" 
              className={`form-control bg-light ${errors.emergencyAddress ? 'is-invalid' : validFields.emergencyAddress ? 'is-valid' : ''}`}
                rows="2"
                 name='emergencyAddress'
                 onChange={handleInputChange}
                 value={formData.emergencyAddress}
              
                ></textarea>
      {errors.emergencyAddress && <small className="text-danger">{errors.emergencyAddress}</small>}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="alternateContactPersonAddress">Alternate Contact Person Address</label>
                <textarea id="alternateContactPersonAddress" className="form-control bg-light" rows="2"
                 name='alternateContactPersonAddress'
                 onChange={handleInputChange}
                 value={formData.alternateContactPersonAddress}
               
                ></textarea>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className="card">
        <div className="card-header bg-light d-flex justify-content-between align-items-center">
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12h8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <h5>TAT Schedule</h5>
                        <div style={{display:'flex',justifyContent:'flex-end',width:'100%'}}>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2" fill="red" />
                        <path d="M8 8l8 8M16 8l-8 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        </div>
                    </div>
        <div className="card-body" style={{display:'flex',flexDirection:'column',gap:'10px'}}>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="toPickupLocationTime">To Pickup Location Time</label>
                <span style={{ color: 'red' }}>*</span>
                <input type="text" 
                // className="form-control bg-light" 
              className={`form-control bg-light ${errors.toPickupLocationTime ? 'is-invalid' : validFields.toPickupLocationTime ? 'is-valid' : ''}`}
                id="toPickupLocationTime" 
                name='toPickupLocationTime'
                onChange={handleInputChange}
                 value={formData.toPickupLocationTime}
               
               />
      {errors.toPickupLocationTime && <small className="text-danger">{errors.toPickupLocationTime}</small>}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="toDeliveryLocationTime">To Delivery Location Time</label>
                <span style={{ color: 'red' }}>*</span>
                <input type="text" 
                // className="form-control bg-light" 
              className={`form-control bg-light ${errors.toDeliveryLocationTime ? 'is-invalid' : validFields.toDeliveryLocationTime ? 'is-valid' : ''}`}
                id="toDeliveryLocationTime" 
                 name='toDeliveryLocationTime'
                 onChange={handleInputChange}
                 value={formData.toDeliveryLocationTime}
               
                />
      {errors.toDeliveryLocationTime && <small className="text-danger">{errors.toDeliveryLocationTime}</small>}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="maximumDeliveryCapacity">Maximum Delivery Capacity</label>
                <span style={{ color: 'red' }}>*</span>
                <input type="text" 
                // className="form-control bg-light" 
              className={`form-control bg-light ${errors.maximumDeliveryCapacity ? 'is-invalid' : validFields.maximumDeliveryCapacity ? 'is-valid' : ''}`}
                id="maximumDeliveryCapacity"
                 name='maximumDeliveryCapacity'
                 onChange={handleInputChange}
                 value={formData.maximumDeliveryCapacity}
                />
      {errors.maximumDeliveryCapacity && <small className="text-danger">{errors.maximumDeliveryCapacity}</small>}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header bg-light d-flex justify-content-between align-items-center">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                <path d="M8 12h8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <h5>Bank Account Details</h5>
            <div style={{display:'flex',justifyContent:'flex-end',width:'100%'}}>
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                <path d="M8 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2" fill="red" />
            <path d="M8 8l8 8M16 8l-8 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
        <div className="card-body" style={{display:'flex',flexDirection:'column',gap:'10px'}}>
        <div className="row">
        <div className="col-md-4 mb-3">
          <label htmlFor="accountHoldersName" className="form-label">Account Holder's Name</label>
          <span style={{ color: 'red' }}>*</span>
          <input 
            type="text" 
            // className="form-control bg-light" 
            className={`form-control bg-light ${errors.accountHoldersName ? 'is-invalid' : validFields.accountHoldersName ? 'is-valid' : ''}`}
            id="accountHoldersName"
            name='accountHoldersName'
            onChange={handleInputChange}
            value={formData.accountHoldersName}
          />
      {errors.accountHoldersName && <small className="text-danger">{errors.accountHoldersName}</small>}
        </div>
        <div className="col-md-4 mb-3" style={{ display: 'flex', flexDirection: 'column' }}>
        <label className="form-label">Type Of Account <span style={{ color: 'red' }}>*</span></label>
        <div 
        // className="btn-group bg-light" 
        className={`btn-group bg-light ${errors.typeOfAccount ? 'is-invalid' : validFields.typeOfAccount ? 'is-valid' : ''}`}
        role="group" aria-label="Type of Account">
          <button
            type="button"
            className={`btn btn-outline-secondary ${formData.typeOfAccount === 'Current' ? 'active' : ''}`}
            onClick={() => handleAccountTypeChange('Current')}
          >
            Current
          </button>
          <button
            type="button"
            className={`btn btn-outline-secondary ${formData.typeOfAccount === 'Savings' ? 'active' : ''}`}
            onClick={() => handleAccountTypeChange('Savings')}
          >
            Savings
          </button>
        </div>
      {errors.typeOfAccount && <small className="text-danger">{errors.typeOfAccount}</small>}
      </div>
        <div className="col-md-4 mb-3">
          <label htmlFor="accountNumber" className="form-label">Account Number</label>
          <span style={{ color: 'red' }}>*</span>
                <span style={{ color: 'red' }}>*</span>
          <input 
            type="text" 
            // className="form-control bg-light" 
            className={`form-control bg-light ${errors.accountNumber ? 'is-invalid' : validFields.accountNumber ? 'is-valid' : ''}`}
            id="accountNumber" 
            name='accountNumber'
            onChange={handleInputChange}
            value={formData.accountNumber}
          />
      {errors.accountNumber && <small className="text-danger">{errors.accountNumber}</small>}
        </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="ifscCode">IFSC Code</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text"
              //  className="form-control bg-light" 
            className={`form-control bg-light ${errors.ifscCode ? 'is-invalid' : validFields.ifscCode ? 'is-valid' : ''}`}
               id="ifscCode"
                name='ifscCode'
                onChange={handleInputChange}
                value={formData.ifscCode}
               />
               {/* {formData.ifscCode && !/^[A-Za-z]{4}\d{7}$/.test(formData.ifscCode) && (
                <div className="text-danger">
                  Please enter a valid IFSC Code (e.g., ABCD1234567)
                </div>
              )} */}
      {errors.ifscCode && <small className="text-danger">{errors.ifscCode}</small>}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="branchName">Branch Name</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text" 
              // className="form-control bg-light"
            className={`form-control bg-light ${errors.branchName ? 'is-invalid' : validFields.branchName ? 'is-valid' : ''}`}
               id="branchName"
               name='branchName'
               onChange={handleInputChange}
                value={formData.branchName}
              />
      {errors.branchName && <small className="text-danger">{errors.branchName}</small>}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="gpayNumber">Gpay Number</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text" 
              // className="form-control bg-light" 
            className={`form-control bg-light ${errors.gpayNumber ? 'is-invalid' : validFields.gpayNumber ? 'is-valid' : ''}`}
              id="gpayNumber"
               name='gpayNumber'
               onChange={handleInputChange}
               value={formData.gpayNumber}
               maxLength="10"
               pattern="\d*"
               inputMode="numeric"
              />
      {errors.gpayNumber && <small className="text-danger">{errors.gpayNumber}</small>}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="bankAddress">Bank Address</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text" 
              // className="form-control bg-light" 
            className={`form-control bg-light ${errors.bankAddress ? 'is-invalid' : validFields.bankAddress ? 'is-valid' : ''}`}
              id="bankAddress" placeholder="Enter Bank Address" 
                name='bankAddress'
                onChange={handleInputChange}
                value={formData.bankAddress}
               />
      {errors.bankAddress && <small className="text-danger">{errors.bankAddress}</small>}
            </div>
          </div>
        </div>
        </div>
      </div>
    </div><br/>
    <div className="delivery-form-actions">
                <button type="button" className="delivery-form-cancel" onClick={() => navigate('/view-delivery-vendor')}>Cancel</button>
                <button type="button" className="delivery-form-submit" onClick={handleUpdate}>Update Delivery Vendor</button>
        </div>
    </div>
          {/* Advanced Map Location Picker Modal */}
      <div className={`modal fade vendor-map-modal ${isMapOpen ? 'show d-block' : ''}`} tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered vendor-map-dialog">
          <div className="modal-content vendor-map-content">
            <div className="modal-header vendor-map-header">
              <div>
                <p>Vendors</p>
                <h5 className="modal-title">Select location</h5>
              </div>
              <button type="button" className="btn-close" onClick={() => setIsMapOpen(false)}></button>
            </div>
            <div className="modal-body vendor-map-body">
              <p className="vendor-map-hint">Search an address, enter coordinates, or click the map to drop a pin.</p>
              <div className="vendor-map-search">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search location..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleGeocode()}
                />
                <button type="button" className="vendor-map-search-btn" onClick={handleGeocode}>
                  Search
                </button>
              </div>

              <div className="vendor-map-coords">
                <div>
                  <label>Latitude</label>
                  <input
                    type="number"
                    className="form-control"
                    step="any"
                    value={manualLat}
                    onChange={(e) => {
                      const v = e.target.value;
                      setManualLat(v);
                      if (v && manualLng) {
                        updateLocation({ lat: parseFloat(v), lng: parseFloat(manualLng) });
                      }
                    }}
                  />
                </div>
                <div>
                  <label>Longitude</label>
                  <input
                    type="number"
                    className="form-control"
                    step="any"
                    value={manualLng}
                    onChange={(e) => {
                      const v = e.target.value;
                      setManualLng(v);
                      if (v && manualLat) {
                        updateLocation({ lat: parseFloat(manualLat), lng: parseFloat(v) });
                      }
                    }}
                  />
                </div>
              </div>

              <div className="vendor-map-frame">
                <MapContainer
                  center={mapCenter}
                  zoom={mapZoom}
                  style={{ height: "100%", width: "100%" }}
                  ref={mapRef}
                >
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <MapClickHandler onSelect={updateLocation} />
                  {mapMarker && <Marker position={[mapMarker.lat, mapMarker.lng]} />}
                </MapContainer>
              </div>
            </div>
            <div className="modal-footer vendor-map-footer">
              <button type="button" className="vendor-map-cancel" onClick={() => setIsMapOpen(false)}>
                Cancel
              </button>
              <button
                type="button"
                className="vendor-map-confirm"
                disabled={!mapMarker}
                onClick={() => {
                  toast.success("Location saved successfully!");
                  setIsMapOpen(false);
                }}
              >
                Confirm Location
              </button>
            </div>
          </div>
        </div>
      </div>
  <div className="delivery-form-footer"><Footer/></div>

  <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 9999 }} 
      />
      </div>
</>
  )
}

export default UpdateDeliveryVendor